import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const SkippedPreview = ({
  recursAnnually
}) => {
  return /*#__PURE__*/_jsx(Alert, {
    type: "info",
    marginBlock: "300",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: recursAnnually ? 'platformTest.details.skippedRecurs' : 'platformTest.details.skipped'
    })
  });
};
export default SkippedPreview;